import { SWRFetcher } from '@commenda/utils';
import { ServiceRequestStatus } from '@prisma/client';
import useSWR from 'swr';
import { API_BASE_PATH } from './constants';

export type ChildServiceRequestSummary = {
  id: string;
  title: string;
  status: ServiceRequestStatus;
  isCommendaFiling: boolean;
};

export const useChildServiceRequests = (serviceRequestId?: string) => {
  const { data, error, isLoading, mutate } = useSWR<{
    data: ChildServiceRequestSummary[];
  }>(
    serviceRequestId ? `${API_BASE_PATH}/${serviceRequestId}/children` : null,
    SWRFetcher({ method: 'GET' })
  );

  return {
    data: data?.data ?? [],
    error,
    isLoading,
    mutate,
  };
};
